import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import i18n from "../../i18n";
import { makeStyles } from "@material-ui/core/styles";

import SelectInput from "../SelectInput";

const useStyles = makeStyles((theme) => ({
  logoHeader: {
    width: "100%",
    backgroundColor: "white",
    color: "black",
    height: "60px",
    padding: "5px 0",
    // marginBottom: "20px",
  },
}));

function EDMHeader({ props }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { allowChangeLang = true } = props;

  useEffect(() => {
    document.title = t("EDM.KGIMarketUpdateSubscription");
  }, []);

  function changeLang(e) {
    i18n.changeLanguage(e.target.value);
    document.title = t("EDM.KGIMarketUpdateSubscription");
  }

  return (
    <div className={classes.logoHeader}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{  textAlign: "left" }}>
          <img
            src={`${process.env.REACT_APP_ROUTER_BASE_URL}/media/KGI-logo.png`}
            style={{ width: "100px" }}
            alt="logo"
          />
        </div>
        <div
          style={{
            paddingRight: "17px",
            marginRight: "0",
          }}
        >
          <SelectInput
            props={{
              id: "Language",
              value: i18n.language.toUpperCase(),
              options: [
                {
                  label: `EN`,
                  value: `EN`,
                },
                {
                  label: `繁中`,
                  value: `CHT`,
                },
                {
                  label: `简中`,
                  value: `CHS`,
                },
              ],
              handleChange: (field, event) => changeLang(event),
              errors: false,
              helperText: "",
              width: "75px",
              height: "28px",
              disabled: !allowChangeLang,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default EDMHeader;
